import type { CSSProperties } from 'react';
import { readTaskContext } from '../logic/task';
import {
  formatLockInDate, validYmd, withdrawalRequestOf, isPausingRequest,
} from '../logic/withdrawalRequest';

interface RequestTask {
  status?: unknown;
  template?: { template_code?: string } | null;
  template_code?: string | null;
  context_json?: unknown;
}

// Mounted on BOTH task surfaces. Display only: the Withdraw window reads the date from the care period.
export default function WithdrawalRequestStatus({ task, style }: { task: RequestTask; style?: CSSProperties }) {
  const view = withdrawalRequestOf(task);
  if (!view) return null;
  const ctx = readTaskContext(task.context_json);
  const ends = validYmd(ctx?.lockin_ends);
  return (
    <div style={{ margin: '6px 0 0', ...style }}>
      <span className="detail1" style={{ fontWeight: 600, fontSize: 11, color: 'var(--wi-text-primary-moderate)' }}>
        Withdrawal request
      </span>
      <p className="detail1 text-secondary" style={{ margin: '2px 0 0', lineHeight: 1.45 }}>
        {`Reason: ${view.reasonLabel}`}
        {ends && ` · Unalignment possible from ${formatLockInDate(ends)}`}
      </p>
      {isPausingRequest(task) && (
        <p className="detail1 text-secondary" style={{ margin: '2px 0 0', lineHeight: 1.45 }}>
          While it is open: no automated messages, and no readings, alerts or tasks from new readings.
        </p>
      )}
    </div>
  );
}
